<script lang="ts">
  let { active = false }: { active?: boolean } = $props();
</script>

<div class="ar-scan-line" class:active></div>
